// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__muktaMalar_75717a', '__muktaMalar_Fallback_75717a', s, a, n, s, -, s, e, r, i, f","fontStyle":"normal"},"className":"__className_75717a"};